<template>
  <a-modal
    :visible="visible"
    :title="title"
    :confirm-loading="loading"
    @ok="submit"
    @cancel="cancel"
  >
    <a-form :form="form">
      <a-form-item label="审批意见">
        <a-textarea v-decorator="['opinion']"></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { approvalWork } from "@/api/base/uploadTask/manager";

export default {
  data() {
    return {
      //modal
      visible: false,
      title: "提示",
      loading: false,
      //form
      form: this.$form.createForm(this),
      //data
      modal: {}
    };
  },
  methods: {
    show(record) {
      this.visible = true;
      if (record) {
        this.modal = record;
      }
    },
    cancel() {
      this.visible = false;
      this.modal = {};
    },
    submit() {
      this.loading = true;
      let params = Object.assign(this.modal, this.form.getFieldsValue());
      approvalWork({ ...params }).then(res => {
        this.$notification[res.resultCode == 1 ? "success" : "error"]({
          message: res.message
        });
        this.cancel();
        this.loading = false;
        this.$emit("ok");
      });
    }
  }
};
</script>

<style scoped></style>
